import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { DEFAULT_NOTE_TYPES_LABELS } from "@/services/api";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  type: string;
  disabled: boolean;
  textColor: string;
};

export const TypeCell: FC<Props> = ({ type, disabled, textColor }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{ color: textColor }}
      className={classNames(styles.root, { [styles.disabled]: disabled })}
    >
      {t(
        `common.noteType.${type !== DEFAULT_NOTE_TYPES_LABELS.DEFAULT_LIFE_STORY ? type?.toLowerCase() : "lifeStory"}`,
        {
          count: 1,
        },
      )}
    </div>
  );
};
